import React, { useState } from "react";
import { Button, Modal, message } from "antd";
import {
  AutoReplyReevaluationStats,
  getReevaluateAutoRepliesStatus,
  startReevaluateAutoReplies,
} from "api/Reviews";

const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

const formatStats = (stats: AutoReplyReevaluationStats) => (
  <div style={{ lineHeight: 1.7 }}>
    <div>Проверено: {stats.checked.toLocaleString("ru-RU")}</div>
    <div>
      Найден лучший шаблон: {stats.betterTemplateFound.toLocaleString("ru-RU")}
    </div>
    <div>Перегенерировано: {stats.regenerated.toLocaleString("ru-RU")}</div>
    <div>Без изменений: {stats.unchanged.toLocaleString("ru-RU")}</div>
    <div>Пропущено: {stats.skipped.toLocaleString("ru-RU")}</div>
    <div>Ошибки: {stats.errors.toLocaleString("ru-RU")}</div>
  </div>
);

export const ReevaluateAutoRepliesButton = () => {
  const [pending, setPending] = useState(false);

  const handleClick = async () => {
    setPending(true);
    try {
      const started = await startReevaluateAutoReplies();
      let status = await getReevaluateAutoRepliesStatus(started.jobId);
      for (let i = 0; i < 120 && status.state !== "completed" && status.state !== "failed"; i++) {
        await sleep(1000);
        status = await getReevaluateAutoRepliesStatus(started.jobId);
        if (status.error === "not_found") {
          message.error("Задача переоценки не найдена");
          return;
        }
      }

      if (status.state === "failed") {
        message.error(status.failedReason || "Переоценка не удалась");
        return;
      }
      if (status.state !== "completed" || !status.stats) {
        message.warning("Переоценка ещё выполняется. Результат появится в задачах.");
        return;
      }
      if (status.stats.unavailable) {
        Modal.warning({
          title: "Переоценить автоответы",
          content: (
            <div>
              <p>
                Embeddings и semantic search ещё не подключены. LLM не вызывался,
                ответы не менялись.
              </p>
              {formatStats(status.stats)}
            </div>
          ),
        });
        return;
      }
      Modal.info({
        title: "Переоценить автоответы",
        content: formatStats(status.stats),
      });
    } catch (error) {
      message.error(
        error instanceof Error ? error.message : "Не удалось запустить переоценку",
      );
    } finally {
      setPending(false);
    }
  };

  return (
    <Button onClick={handleClick} loading={pending}>
      Переоценить автоответы
    </Button>
  );
};
